export default "__VITE_ASSET__MmYfXhT9__"